import { AlertModal } from "@/components/generic/AlertModal";
import { Checkbox } from "@/components/generic/Checkbox";
import { useLocalStorageFlag } from "@/hooks/use-local-storage-flag";
import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";

interface ConfirmBoostDialogProps {
  maxCredits: number;
  onConfirm: () => void;
  onCancel: () => void;
}

interface FormValues {
  noShow: boolean;
}

export function ConfirmBoostDialog({
  maxCredits,
  onConfirm,
  onCancel,
}: ConfirmBoostDialogProps) {
  const { isExist, setItem } = useLocalStorageFlag({
    key: "suppressBoostConfirmation",
  });

  const { control, getValues } = useForm<FormValues>({
    defaultValues: { noShow: false },
  });

  useEffect(() => {
    if (isExist) {
      onConfirm();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AlertModal
      iconDisable={true}
      title="Bekræft brug af credits"
      description={`Denne levering inkluderer kontaktoplysninger, og vil koste op til ${maxCredits} credits. Start levering?`}
      confirmation={
        <Controller
          name="noShow"
          control={control}
          render={({ field }) => (
            <Checkbox
              boxClassName="border-theme-outline-variant"
              className="text-theme-on-glass-variant"
              isSelected={field.value}
              value="noShow"
              onChange={field.onChange}
            >
              Vis ikke igen
            </Checkbox>
          )}
        />
      }
      confirmButtonText="Start"
      onClose={onCancel}
      onConfirm={() => {
        if (getValues("noShow")) {
          setItem();
        }

        onConfirm();
      }}
    />
  );
}
